import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=35b11994&scoped=true&"
import script from "./DocumentListItem.vue?vue&type=script&lang=js&"
export * from "./DocumentListItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=35b11994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b11994",
  null
  
)

export default component.exports